import { useCallback, useSyncExternalStore } from 'react'

const POS_ID_KEY = 'posId'

const subscribe = (callback: () => void) => {
  window.addEventListener('storage', callback)
  return () => window.removeEventListener('storage', callback)
}

const getSnapshot = () => localStorage.getItem(POS_ID_KEY) ?? ''

export const usePosId = () => {
  const posId = useSyncExternalStore(subscribe, getSnapshot)

  const setPosId = useCallback((value: string) => {
    localStorage.setItem(POS_ID_KEY, value)
    window.dispatchEvent(new StorageEvent('storage', { key: POS_ID_KEY }))
  }, [])

  return { posId, setPosId }
}
